import { formatAttendanceDate, getWeekOfMonth } from "src/utils/formatdate";
import { statusMap } from "./status-map";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReAttendanceDeleteButton } from "../components/re-attendance-delete-button";

export const formatBusScheduleDisplay = (attendance, prefix) => {
  const schedule = attendance.bus_schedule;
  const route = attendance[`${prefix}_bus_route`];
  if (!schedule) return null;
  return `${schedule.bus_course.code} (${route?.stop_name} ${route?.[`formatted_${prefix}_bus_stop_time`]})`;
};

export const columns = onModal => [
  {
    title: "出欠枠",
    dataIndex: "attendanceBlock",
    key: "attendanceBlock",
    width: "100px",
    align: "center",
    render: (_, { attendance_date }) => {
      return <div>第{getWeekOfMonth(attendance_date)}週</div>;
    },
  },
  {
    title: "日時",
    dataIndex: "attendance_date",
    key: "attendance_date",
    width: "200px",
    align: "center",
    render: (_, row) => {
      return formatAttendanceDate(row);
    },
  },
  {
    title: "級",
    dataIndex: "rank",
    key: "rank",
    width: "75px",
    align: "center",
    render: (_, { rank }) => {
      return rank;
    },
  },
  {
    title: "出欠状況",
    dataIndex: "status",
    key: "status",
    width: "120px",
    align: "center",
    render: status => {
      const label = statusMap[status];
      return <div>{label}</div>;
    },
  },
  {
    title: "振替元",
    key: "rescheduled",
    dataIndex: "rescheduled",
    width: "200px",
    align: "center",
    render: (_, { re_attendance }) =>
      re_attendance && formatAttendanceDate(re_attendance),
  },
  {
    title: "備考",
    dataIndex: "comment",
    key: "comment",
    minWidth: "100px",
    align: "center",
  },
  {
    title: "システム備考",
    dataIndex: "system_comment",
    key: "system_comment",
    minWidth: "100px",
    align: "center",
  },
  {
    title: "往路バス",
    dataIndex: "outbound_bus_schedule_id",
    key: "outbound_bus_schedule_id",
    width: "200px",
    align: "center",
    render: (_, row) => {
      return formatBusScheduleDisplay(row, "outbound");
    },
  },
  {
    title: "往追加",
    dataIndex: "outbound_passengers",
    key: "outbound_passengers",
    width: "75px",
    align: "center",
    render: (_, row) => {
      return row.outbound_passengers > 0 ? row.outbound_passengers - 1 : null;
    },
  },
  {
    title: "復路バス",
    dataIndex: "return_bus_schedule_id",
    key: "return_bus_schedule_id",
    width: "200px",
    align: "center",
    render: (_, row) => {
      return formatBusScheduleDisplay(row, "return");
    },
  },
  {
    title: "復追加",
    dataIndex: "return_passengers",
    key: "return_passengers",
    width: "75px",
    align: "center",
    render: (_, row) => {
      return row.return_passengers > 0 ? row.return_passengers - 1 : null;
    },
  },
  {
    title: "操作",
    key: "action",
    width: "180px",
    align: "center",
    render: (_, row) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          gap: "5px",
        }}
      >
        <>
          {row.can_reschedule && (
            <span>
              <button
                onClick={() => onModal("furikae", row)}
                className="btn btn-primary w-100 btn-sm-custom"
              >
                振替
              </button>
            </span>
          )}
          {!["absent", "absent_schcon", "absent_alert"].includes(
            row.status
          ) && (
            <span>
              <button
                onClick={() => onModal("bus", row)}
                className="btn btn-primary w-100 btn-sm-custom"
              >
                バス
              </button>
            </span>
          )}
          <span>
            <button
              onClick={() => onModal("attendance", row)}
              className="btn btn-primary w-100 btn-sm-custom"
            >
              <FontAwesomeIcon icon="edit" />
            </button>
          </span>
          <ReAttendanceDeleteButton attendance={row} />
        </>
      </div>
    ),
  },
];
